package one.healthium.url_provider.di

import one.healthium.url_provider.data.AppUrlProviderRepository
import one.healthium.url_provider.data.api.UrlProviderApiClient
import one.healthium.url_provider.domain.UrlProviderRepository
import org.koin.core.module.dsl.singleOf
import org.koin.dsl.bind
import org.koin.dsl.module

val urlProviderModule = module {
    single {
        UrlProviderApiClient.factory(UrlProviderApiClient.createBaseHttpClient(get()), get())
    }
    singleOf(::AppUrlProviderRepository) bind UrlProviderRepository::class
}